export default __webpack_public_path__ + "static/Continuous Integration 3-ac17520d3b280953a1c85ac7a9dc9d74.png";